
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { Kontrakt } from "../../models/kontrakt-models";
import { KontraktCommandBase } from "./KontraktCommandBase";

export class UpdateKontraktCommand extends KontraktCommandBase {
    readonly kontrakt: Kontrakt;
    readonly isDefaultKontrakt: boolean;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateKontraktCommand";

    constructor(avtalGuid: string, kontrakt: Kontrakt, isDefaultKontrakt = false) {
        super(avtalGuid, kontrakt.guid, UpdateKontraktCommand.$type, CommandType.Replace);
        this.kontrakt = kontrakt;
        this.isDefaultKontrakt = isDefaultKontrakt;
    }
}
